import {ref} from "vue"
import {defineStore, acceptHMRUpdate} from "pinia"

export const useAppStore = defineStore("app", () => {
  // state
  const app = ref({})
  const modal = ref({
    visible: false,
    type: null,
    title: "",
    message: "",
    buttons: [],
    payload: null,
  })

  // getters

  // actions
  function modalShow(args) {
    modal.value.visible = true
    modal.value.type = args.type
    modal.value.message = args.message
    modal.value.payload = args.payload
    modal.value.buttons.splice(0)
    args.buttons.forEach((button) => {
      modal.value.buttons.push(button)
    })
  }

  function modalHide() {
    modal.value.visible = false
  }

  function modalExecute(button) {
    button.action(modal.value.payload)
  }

  return {
    // state
    app,
    modal,

    // getters

    // actions
    modalShow,
    modalHide,
    modalExecute,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
